import { Card, Grid, Tooltip, Typography } from '@mui/material'
import { linkContributorsDepartments } from 'carto/constants/CartoConstants'
import PropTypes from 'prop-types'
import React, { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import i18n from 'simple-react-i18n'
import { getArrestColor } from '../../../utils/ColorUtil'
import { hasValue } from '../../../utils/NumberUtil'
import { getSetting, getSettingJson } from '../../../utils/SettingUtils'
import HomeAction from '../../actions/HomeAction'
import { OpenInNew } from '@mui/icons-material'
import { orderBy } from 'lodash'

const PrefectoralArrestPanel = ({ townCode }) => {
    const dispatch = useDispatch()
    const arrests = useSelector(store => store.HomeReducer.arrests)
    const applicationSettings = useSelector(store => store.AdministrationReducer.applicationSettings)
    const accountUser = useSelector(store => store.AccountReducer.accountUser)

    const displayedArrests = useMemo(() => arrests.filter(o => o.typeArrest === i18n.reinforcedAlert || o.typeArrest === i18n.crisis), [arrests])

    useEffect(() => {
        const getDepartments = () => {
            const contribSettings = hasValue(accountUser.contributorCode)
                ? (getSettingJson(applicationSettings, linkContributorsDepartments) || []).find(s => s.contributor === accountUser.contributorCode)
                : null
            return contribSettings?.departments || getSetting(applicationSettings, 'arrestDepartments')
        }
        const departments = townCode ? townCode.slice(0, 2) : getDepartments()
        if (hasValue(departments) && departments.length >= 2) {
            dispatch(HomeAction.fetchArrests(departments))
        }
    }, [townCode, applicationSettings, accountUser, dispatch])

    return !!displayedArrests.length && (
        <Card>
            {displayedArrests.map((arrest, index) => {
                const isLast = index === displayedArrests.length - 1
                const [firstWord, secondWord = ''] = arrest.typeArrest.split(' ')
                const zones = orderBy(arrest?.zones, ['level', 'name'], ['desc', 'asc'])?.map(z => `${z.name} (${z.restriction})`)?.join('\n')
                return (
                    <Tooltip
                        key={arrest.id}
                        title={<span style={{ whiteSpace: 'pre-wrap' }}>{zones}</span>}
                        placement='left'
                    >
                        <Grid
                            container
                            onClick={() => window.open(arrest.ddtURL, '_blank')}
                            sx={{
                                cursor: 'pointer',
                                fontSize: '11px',
                                borderBottom: isLast ? '' : '1px solid #eee',
                            }}
                        >
                            <Grid
                                size={2}
                                sx={{
                                    backgroundColor: getArrestColor(arrest.typeArrest),
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    textAlign: 'center',
                                    fontWeight: 'bold',
                                    borderTopLeftRadius: index === 0 ? 4 : 0,
                                    borderBottomLeftRadius: isLast ? 4 : 0,
                                }}
                            >
                                {firstWord}<br/>{secondWord}
                            </Grid>
                            <Grid size='grow' sx={{ backgroundColor: 'background.paper', pl: 1 }}>
                                <Typography fontWeight='bold'>
                                    {`${arrest.alerteZone} - ${arrest.title}`}
                                </Typography>
                                <Typography sx={{ fontSize: '11px' }}>
                                    {arrest.comment}
                                </Typography>
                            </Grid>
                            <Grid size='auto'>
                                <OpenInNew />
                            </Grid>
                        </Grid>
                    </Tooltip>
                )
            })}
        </Card>
    )
}

PrefectoralArrestPanel.propTypes = {
    townCode: PropTypes.string,
}

export default PrefectoralArrestPanel
